// packages/world-model/src/traits/listener/index.ts

export { ListenerTrait } from './listenerTrait';
